import React from 'react';
import { CalendarDays } from 'lucide-react';
import {
  DATE_RANGE_OPTIONS, EMPTY_DATE_RANGE, todayInputValue,
} from '../lib/dateRange';

// Geçmiş ekranlarının ortak tarih süzgeci: 1 gün / 1 hafta / 1 ay hazır
// aralıkları ve serbest tarih seçimi. Finans işlemleri, casino turları ve
// spor kuponları aynı bileşeni çizer — biri değişirse hepsi değişsin diye.
//
// Süzgeç değeri ``{ range, from, to }`` şeklindedir; istek parametreleri
// ``dateRangeParams()`` ile üretilir (lib/dateRange.js).

const DateRangeFilter = ({ value, onChange, className = '' }) => {
  const current = value || EMPTY_DATE_RANGE;
  const today = todayInputValue();

  const choose = (range) => {
    if (range === current.range) return;
    // Hazır aralığa dönerken girilen tarihler korunur: yönetici genelde
    // "son bir ay"a bakıp aynı özel aralığa geri döner.
    onChange({ ...current, range });
  };

  return (
    <div className={`admin-date-range ${className}`.trim()}>
      {DATE_RANGE_OPTIONS.map((option) => (
        <button
          key={option.id}
          type="button"
          onClick={() => choose(option.id)}
          className={`admin-tab ${current.range === option.id ? 'active' : ''}`}
          aria-pressed={current.range === option.id}
        >
          {option.id === 'custom' && (
            <CalendarDays size={13} aria-hidden="true" />
          )}
          {option.label}
        </button>
      ))}
      {current.range === 'custom' && (
        <div className="admin-date-range-custom">
          <label className="sr-only" htmlFor="date-range-from">
            Başlangıç tarihi
          </label>
          <input
            id="date-range-from"
            type="date"
            value={current.from || ''}
            max={current.to || today}
            onChange={(event) => onChange({ ...current, from: event.target.value })}
            className="admin-input admin-date-input"
          />
          {/* Saat isteğe bağlıdır (Türkiye saati); boşsa gün başıdır. */}
          <label className="sr-only" htmlFor="date-range-from-time">
            Başlangıç saati
          </label>
          <input
            id="date-range-from-time"
            type="time"
            value={current.fromTime || ''}
            onChange={(event) => onChange({ ...current, fromTime: event.target.value })}
            className="admin-input admin-time-input"
            title="Başlangıç saati (isteğe bağlı)"
          />
          <span className="admin-date-range-sep" aria-hidden="true">–</span>
          <label className="sr-only" htmlFor="date-range-to">
            Bitiş tarihi
          </label>
          <input
            id="date-range-to"
            type="date"
            value={current.to || ''}
            min={current.from || undefined}
            max={today}
            onChange={(event) => onChange({ ...current, to: event.target.value })}
            className="admin-input admin-date-input"
          />
          {/* Bitiş saati o dakikanın sonuna kadar sayılır; boşsa günün
              tamamıdır. Bitiş tarihi boşken girilen saat başlangıç günüdür. */}
          <label className="sr-only" htmlFor="date-range-to-time">
            Bitiş saati
          </label>
          <input
            id="date-range-to-time"
            type="time"
            value={current.toTime || ''}
            onChange={(event) => onChange({ ...current, toTime: event.target.value })}
            className="admin-input admin-time-input"
            title="Bitiş saati (isteğe bağlı)"
          />
          {!current.from && !current.to && (
            // Boş bırakılan aralık süzgeç uygulamaz; yönetici "tarih seçtim
            // ama liste değişmedi" diye düşünmesin.
            <span className="admin-date-range-hint">Tarih seçilmedi</span>
          )}
        </div>
      )}
    </div>
  );
};

export default DateRangeFilter;
